import { useContext } from 'react';

import { media } from 'context';
import { Layout, Text } from 'ds';

import OfficeExperienceCardsSwiper from './OfficeExperienceCardsSwiperCarousel';

interface OfficeSetupMadeEasyProps {
  onCardClick: (index: number) => void;
}

const OfficeSetupMadeEasy = ({ onCardClick }: OfficeSetupMadeEasyProps) => {
  const { isMobile } = useContext(media);
  return (
    <Layout flex direction="column" gap={24}>
      <Layout flex direction="column" gap={12}>
        <Text size={isMobile ? 'headline-xs' : 'headline-md'}>Office setup, made easy</Text>
        <Text size="body-sm" color="gray-700">
          Effortlessly set up and manage your space with curated office essentials and amenities—all in one centralized
          platform.
        </Text>
      </Layout>
      <OfficeExperienceCardsSwiper onCardClick={onCardClick} />
    </Layout>
  );
};

export default OfficeSetupMadeEasy;
